import React from 'react';
import './ClientsPage.css';

import { Heading, PageTitle } from '../../../components';
import { clients } from '../../../constants';



const ClientsPage = () => {
  return (
    <>
      {/* Page Title */}
      <PageTitle title={'Client'} page={'Client'} />

      <section className='clients'>

        {/* Section heading */}
        <Heading title={'Our Client'} subTitle={'Driving Success Together'} />

        <div className='box-container'>

          {/* Loop through the clients array to display each client's logo */}
          {clients.map((client, index) => {
              return (
                <div className='client-item' key={index}>
                  {/* Render the Client logo */}
                  <img src={client} alt='Client Logo' />
                </div>
              );
            })
          }

        </div>

      </section>

    </>
  );
}

export default ClientsPage;